import * as ticketApi from '@/api/ticket'

const state = {
  lastListParams: null
}

const mutations = {
  SET_LAST_LIST_PARAMS(state, payload) {
    state.lastListParams = payload
  }
}

const actions = {
  list({ commit }, params) {
    commit('SET_LAST_LIST_PARAMS', params)
    return ticketApi.getTicketList(params)
  },
  detail({ commit }, params) {
    return ticketApi.getTicketDetail(params)
  },
  create({ commit }, data) {
    return ticketApi.createTicket(data)
  },
  update({ commit }, data) {
    return ticketApi.updateTicket(data)
  },
  updateStatus({ commit }, data) {
    return ticketApi.updateTicketStatus(data)
  },
  assignAgent({ commit }, data) {
    return ticketApi.assignTicketAgent(data)
  },
  addNote({ commit }, data) {
    return ticketApi.addTicketNote(data)
  },
  activity({ commit }, params) {
    return ticketApi.getTicketActivity(params)
  },
  statistics({ commit }) {
    return ticketApi.getTicketStatistics()
  },
  agents({ commit }, params) {
    return ticketApi.getTicketAgents(params || {})
  },
  kanban({ commit }, params) {
    return ticketApi.getTicketKanban(params || {})
  },
  kanbanReorder({ commit }, data) {
    return ticketApi.reorderTicketKanban(data)
  },
  bulkUpdate({ commit }, data) {
    return ticketApi.bulkUpdateTickets(data)
  },
  followUp({ commit }, params) {
    return ticketApi.getTicketFollowUp(params)
  },
  scheduleFollowUp({ commit }, data) {
    return ticketApi.scheduleTicketFollowUp(data)
  },
  bulkScheduleFollowUp({ commit }, data) {
    return ticketApi.bulkScheduleTicketFollowUp(data)
  },
  cancelFollowUp({ commit }, data) {
    return ticketApi.cancelTicketFollowUp(data)
  },
  attachments({ commit }, ticketId) {
    return ticketApi.getTicketAttachments(ticketId)
  },
  uploadAttachments({ commit }, data) {
    const payload = data || {}
    return ticketApi.uploadTicketAttachments(
      payload.ticketId,
      payload.files,
      payload.onProgress
    )
  },
  downloadAttachment({ commit }, id) {
    return ticketApi.downloadTicketAttachment(id)
  },
  deleteAttachment({ commit }, id) {
    return ticketApi.deleteTicketAttachment(id)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/ticket.js